export const preLoadImages = async (imagesList: string[]) => {
  imagesList.forEach(imageUrl => {
    try {
      const loadImg = new Image();
      loadImg.src = imageUrl;
    } catch (e) {}
  });
};
